import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import IconContainer from 'presentation/components/icons/IconContainer';
import { LOCATIONS } from 'app/modules/ui/constants';
import { navigateForward } from 'app/modules/ui/actions';
import overrideStyles from 'lib/overrideStyle';
import { updateSelectedAnswer } from 'app/modules/self_service';

const SearchedAnswerItem = overrideStyles('div')`
  cursor: pointer;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  padding: 20px 15px;
  &:hover {
    color: #009b00;
  }
  &:active, &:focus {
    outline: none;
  }
`;

const HighlightedSearchedAnswerItem = overrideStyles(SearchedAnswerItem)`
  color: #009b00;
`;

const ChevronWrapper = overrideStyles('div')`
  display: flex;
  flex: 1 0 auto;
  justify-content: flex-end;
`;

const NameWrapper = overrideStyles('div')`
  cursor: pointer;
  flex: 1 1 auto;
  height: 15px;
  overflow: hidden ;
  text-overflow: ellipsis;
  white-space: nowrap ;
`;

class SearchResultsItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    SearchResultsItem.propTypes = {
      name: PropTypes.string.isRequired,
      focused: PropTypes.bool.isRequired,
    };
    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  handleMouseDown() {
    this.props.onMouseDown(this.props.answerId);
  }

  renderKeyFocusedItem() {
    return this.props.focused ? (
      <HighlightedSearchedAnswerItem role="button" tabIndex="0" onMouseDown={this.handleMouseDown}>
        <NameWrapper>{this.props.name}</NameWrapper>
        <ChevronWrapper>></ChevronWrapper>
      </HighlightedSearchedAnswerItem>
    ) : (
      <SearchedAnswerItem role="button" tabIndex="0" onMouseDown={this.handleMouseDown}>
        <NameWrapper>{this.props.name}</NameWrapper>
        <ChevronWrapper>></ChevronWrapper>
      </SearchedAnswerItem>
    );
  }

  render() {
    return this.renderKeyFocusedItem();
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    onMouseDown: answerId => {
      dispatch(updateSelectedAnswer(answerId));
      dispatch(navigateForward(LOCATIONS.ANSWER));
    },
  };
};

const SearchResultsItemContainer = connect(
  null,
  mapDispatchToProps
)(SearchResultsItem);

export default SearchResultsItemContainer;
